module.exports = __webpack_public_path__ + "static/media/magnifying-glass.962dfe81.svg";